import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  ViewChild,
  ComponentFactoryResolver,
  ViewContainerRef,
} from "@angular/core";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {AddDynamicComponentDirective} from "../../directives/add-dynamic-component.directive";
import {DynamicComponentItem} from "../../models/dynamic-component-loader/DynamicComponentItem.model";
import {IDynamicComponent} from "../../models/dynamic-component-loader/IDynamicComponent.model";

export class ConfirmDialogParams {
  public hideCancel: boolean = null;
  public showCloseIcon = true;
  public disableClose = false;

  constructor(
    public title: string = null,
    public description: string = null,
    public actionLabel: string = null,
    public cancelLabel: string = null,
    public panelClass: string = null,
    public svgIcon: string = null,
    public secondaryActionLabel: string = null,
    public actionButtonColor: string = "primary",
    public dynamicComponent: DynamicComponentItem = null,
    public vcr: ViewContainerRef = null,
    public actionPosition: "left" | "center" | "right" = "left",
    public highlightText: string = null,
    public icon: string = null,
    public iconClass: string = null,
    public disableAction: boolean = false,
    public highlightColor: string = '#FFF5DD',
    public actionButtonColorCode: string = null,
    public autoFocus: boolean = true,
  ) { }
}

@Component({
  selector: "terra-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
  // for dynamic component loader
  @ViewChild(AddDynamicComponentDirective, {static: true})
  terraAddDynamicComponent!: AddDynamicComponentDirective;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogParams,
    private componentFactoryResolver: ComponentFactoryResolver
  ) { }

  ngOnInit() {
    if (this.data.dynamicComponent) {
      this.loadComponent();
    }

    if (this.data.panelClass) {
      this.dialogRef.addPanelClass(this.data.panelClass);
    }
  }

  // for dynamic component loader
  loadComponent() {
    const viewContainerRef = this.terraAddDynamicComponent.viewContainerRef;
    viewContainerRef.clear();
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        this.data.dynamicComponent.component
      );
    const componentRef =
      viewContainerRef.createComponent<IDynamicComponent>(componentFactory);
    componentRef.instance.data = this.data.dynamicComponent.data;
  }

  action() {
    this.dialogRef.close(true);
  }

  secondaryAction() {
    this.dialogRef.close({secondaryAction: true});
  }
}
